export default __webpack_public_path__ + "static/media/location_preview_s4_brilliant_beach.6a7b925f.svg";